import React from 'react';
import { IcoCheck } from 'icone';
import { PeriodicReportingType } from '../PeriodicReporting';
import { format, isValid } from 'date-fns';

interface PeriodicReportingCheckCellProps {
	data: PeriodicReportingType;
	value: boolean;
	colDef: { field: string };
}

const PeriodicReportingCheckCell: React.FC<PeriodicReportingCheckCellProps> = ({ data, value, colDef: { field } }) => {
	if (!value) return;

	const selectedDate = data[`${field}Date`];
	const formattedDate = selectedDate && isValid(new Date(selectedDate)) ? format(selectedDate, 'dd/MM/yyyy') : '';

	return formattedDate ? (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				gap: '0.5rem',
			}}
		>
			<IcoCheck style={{ fill: '#689689' }} />
			<span style={{ marginTop: '1px' }}>{formattedDate}</span>
		</div>
	) : (
		<IcoCheck style={{ fill: '#689689' }} />
	);
};

export default PeriodicReportingCheckCell;
